// extracted by mini-css-extract-plugin
export var blockedMessage = "_ba-3";
export var blockedOverlay = "_ba-1";
export var fadeIn = "_ba-2";
export var hereLink = "_ba-0";
export var slideUp = "_ba-4";